import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "Sloven\u010Dina",
  code: "sk",
  messages: {
    alert: {
      close: "Zatvori\u0165"
    },
    authForm: {
      hidePassword: "Skry\u0165 heslo",
      showPassword: "Zobrazi\u0165 heslo",
      submit: "Pokra\u010Dova\u0165"
    },
    banner: {
      close: "Zatvori\u0165"
    },
    calendar: {
      nextMonth: "Nasleduj\xFAci mesiac",
      nextYear: "Nasleduj\xFAci rok",
      prevMonth: "Predch\xE1dzaj\xFAci mesiac",
      prevYear: "Predch\xE1dzaj\xFAci rok"
    },
    carousel: {
      dots: "Vyberte sn\xEDmku na zobrazenie",
      goto: "Prejs\u0165 na {slide}",
      next: "Nasleduj\xFAci",
      prev: "Predch\xE1dzaj\xFAci"
    },
    chatPrompt: {
      placeholder: "Tu nap\xED\u0161te svoje spr\xE1vu..."
    },
    chatPromptSubmit: {
      label: "Odosla\u0165"
    },
    colorMode: {
      dark: "Tmav\xFD",
      light: "Svetl\xFD",
      switchToDark: "Prepn\xFA\u0165 na tmav\xFD re\u017Eim",
      switchToLight: "Prepn\xFA\u0165 na svetl\xFD re\u017Eim",
      system: "Syst\xE9m"
    },
    commandPalette: {
      back: "Sp\xE4\u0165",
      close: "Zavrie\u0165",
      noData: "\u017Diadne d\xE1ta",
      noMatch: "\u017Diadna zhoda",
      placeholder: "Zadajte pr\xEDkaz alebo vyh\u013Eadajte..."
    },
    contentSearch: {
      links: "Odkazy",
      theme: "T\xE9ma"
    },
    contentSearchButton: {
      label: "H\u013Eada\u0165..."
    },
    contentToc: {
      title: "Na tejto str\xE1nke"
    },
    dashboardSearch: {
      theme: "T\xE9ma"
    },
    dashboardSearchButton: {
      label: "H\u013Eada\u0165..."
    },
    dashboardSidebarCollapse: {
      collapse: "Zbali\u0165 bo\u010Dn\xFD panel",
      expand: "Rozbali\u0165 bo\u010Dn\xFD panel"
    },
    dashboardSidebarToggle: {
      close: "Zatvori\u0165 bo\u010Dn\xFD panel",
      open: "Otvori\u0165 bo\u010Dn\xFD panel"
    },
    error: {
      clear: "Sp\xE4\u0165 na domovsk\xFA str\xE1nku"
    },
    fileUpload: {
      removeFile: "Odobra\u0165 {filename}"
    },
    header: {
      close: "Zatvori\u0165 menu",
      open: "Otvori\u0165 menu"
    },
    inputMenu: {
      create: 'Vytvori\u0165 "{label}"',
      noData: "\u017Diadne d\xE1ta",
      noMatch: "\u017Diadna zhoda"
    },
    inputNumber: {
      decrement: "Zn\xED\u017Ei\u0165",
      increment: "Zv\xFD\u0161i\u0165"
    },
    modal: {
      close: "Zatvori\u0165"
    },
    pricingTable: {
      caption: "Porovnanie cien"
    },
    prose: {
      codeCollapse: {
        closeText: "Zbali\u0165",
        name: "k\xF3d",
        openText: "Rozbali\u0165"
      },
      collapsible: {
        closeText: "Skry\u0165",
        name: "vlastnosti",
        openText: "Zobrazi\u0165"
      },
      pre: {
        copy: "Kop\xEDrova\u0165 k\xF3d do schr\xE1nky"
      }
    },
    selectMenu: {
      create: 'Vytvori\u0165 "{label}"',
      noData: "\u017Diadne d\xE1ta",
      noMatch: "\u017Diadna zhoda",
      search: "H\u013Eada\u0165..."
    },
    slideover: {
      close: "Zatvori\u0165"
    },
    table: {
      noData: "\u017Diadne d\xE1ta"
    },
    toast: {
      close: "Zatvori\u0165"
    }
  }
});
